/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface DigitalPaymentSuccessResponse
 */
export interface DigitalPaymentSuccessResponse {
    /**
     * 
     * @type {PaymentState}
     * @memberof DigitalPaymentSuccessResponse
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof DigitalPaymentSuccessResponse
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof DigitalPaymentSuccessResponse
     */
    bookingReference: string;
    /**
     * 
     * @type {number}
     * @memberof DigitalPaymentSuccessResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof DigitalPaymentSuccessResponse
     */
    redirectUrl?: string;
}

/**
 * Check if a given object implements the DigitalPaymentSuccessResponse interface.
 */
export function instanceOfDigitalPaymentSuccessResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "bookingReference" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function DigitalPaymentSuccessResponseFromJSON(json: any): DigitalPaymentSuccessResponse {
    return DigitalPaymentSuccessResponseFromJSONTyped(json, false);
}

export function DigitalPaymentSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitalPaymentSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentReference': json['paymentReference'],
        'bookingReference': json['bookingReference'],
        'amount': json['amount'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
    };
}

export function DigitalPaymentSuccessResponseToJSON(value?: DigitalPaymentSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentReference': value.paymentReference,
        'bookingReference': value.bookingReference,
        'amount': value.amount,
        'redirectUrl': value.redirectUrl,
    };
}

